import { render } from "./SignUpEditorCmp.vue?vue&type=template&id=bd1f4612"
import script from "./SignUpEditorCmp.vue?vue&type=script&lang=js"
export * from "./SignUpEditorCmp.vue?vue&type=script&lang=js"

import "./SignUpEditorCmp.vue?vue&type=style&index=0&id=bd1f4612&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__